<section>
    <iq-builder-events-trace-diagram
        [traceMap]="traceMap()"
        (selected)="selectEvent($event)"
    />
    @if(selectedName()?.length){
    <hr class="my-2 h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10" />
    <section class="my-8">
        <header
            class="w-full justify-between flex items-center px-2 py-2 cursor-pointer"
        >
            <h3 class="title-large">
                <span class="title-large-strong pr-2">Payload:</span
                >{{ selectedName() }}
            </h3>
        </header>
        <main class="px-2 mt-2">
            <pre
                class="rounded-md p-4 bg-dat-grey-900 text-white max-h-[400px] w-full h-full overflow-y-scroll"
                >{{ payload() | json }}</pre
            >
        </main>
    </section>
    }
</section>
